module.exports = __webpack_public_path__ + "assets/img/the-buzz-active.54225f1a.svg";